import { render, staticRenderFns } from "./BaseSortableHeader.vue?vue&type=template&id=a1a622d2&scoped=true"
import script from "./BaseSortableHeader.vue?vue&type=script&lang=js"
export * from "./BaseSortableHeader.vue?vue&type=script&lang=js"
import style0 from "./BaseSortableHeader.vue?vue&type=style&index=0&id=a1a622d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a622d2",
  null
  
)

export default component.exports